import React, { useState } from "react";
import { shippingData } from "../services/shippingData";

const GenerateShippingDocuments = () => {
    const [selectedBoxes, setSelectedBoxes] = useState([]);

    const handleBoxSelection = (boxId) => {
        setSelectedBoxes((prevSelected) =>
            prevSelected.includes(boxId)
                ? prevSelected.filter((id) => id !== boxId)
                : [...prevSelected, boxId]
        );
    };

    const handleGenerateDocuments = () => {
        if (selectedBoxes.length === 0) {
            alert("Veuillez sélectionner au moins une boîte pour générer les documents.");
            return;
        }

        const documentContent = `Documents d'expédition pour les boîtes suivantes :\n\n${selectedBoxes.join(
            ", "
        )}`;
        const blob = new Blob([documentContent], { type: "text/plain;charset=utf-8" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", "shipping_documents.txt");
        link.click();

        alert(`Documents générés pour les boîtes : ${selectedBoxes.join(", ")}`);
    };

    return (
        <div className="max-w-6xl mx-auto p-4">
            <h1 className="text-2xl font-bold mb-6">Génération des documents d’expédition</h1>

            {/* Tableau des boîtes prêtes */}
            <div className="bg-white shadow-md rounded p-4">
                <h2 className="text-lg font-bold mb-4">Sélectionnez les boîtes prêtes à expédier :</h2>
                {shippingData.filter((box) => box.status === "Prête pour expédition").length > 0 ? (
                    <table className="w-full border-collapse border border-gray-300">
                        <thead>
                            <tr className="bg-gray-100">
                                <th className="border border-gray-300 p-2">Sélectionner</th>
                                <th className="border border-gray-300 p-2">Nom de la boîte</th>
                                <th className="border border-gray-300 p-2">Destination</th>
                            </tr>
                        </thead>
                        <tbody>
                            {shippingData
                                .filter((box) => box.status === "Prête pour expédition")
                                .map((box) => (
                                    <tr key={box.id}>
                                        <td className="border border-gray-300 p-2 text-center">
                                            <input
                                                type="checkbox"
                                                checked={selectedBoxes.includes(box.id)}
                                                onChange={() => handleBoxSelection(box.id)}
                                            />
                                        </td>
                                        <td className="border border-gray-300 p-2">{box.name}</td>
                                        <td className="border border-gray-300 p-2">{box.destination}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                ) : (
                    <p className="text-center text-gray-500">Aucune boîte prête à expédier.</p>
                )}
            </div>

            {/* Bouton de génération */}
            <div className="mt-4">
                <button
                    onClick={handleGenerateDocuments}
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-700"
                >
                    Générer les documents
                </button>
            </div>
        </div>
    );
};

export default GenerateShippingDocuments;
